const PREFIX = 'VOUCHER_PROGRAMS_LIST_';

export const GET_VOUCHER_PROGRAMS = `${PREFIX}GET_VOUCHER_PROGRAMS`;
export const SET_VOUCHER_PROGRAMS = `${PREFIX}SET_VOUCHER_PROGRAMS`;